// @flow
import React from 'react';
import { defineMessages, injectIntl, type IntlShape } from 'react-intl';

import Text from './Text';
import Image from './Image';
import Box from './Box';
import type { TextProps } from './Text';

const messages = defineMessages({
  loadingText: {
    defaultMessage: 'Loading...',
    id: 'loading.loadingText',
  },
  longLoadingText: {
    defaultMessage: 'Still loading, please check your connection...',
    id: 'loading.longLoadingText',
  },
  noDataText: {
    defaultMessage:
      'We are unable to load this page. Please make sure you are connected to the internet.',
    id: 'loading.noDataText',
  },
});

const styles = {
  spinner: () => ({
    display: 'flex',
    marginTop: '10%',
    marginBottom: '5%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 30,
  }),
  loadingTxt: {
    marginTop: 10,
  },
};

type LoadingProps = TextProps & {
  intl: IntlShape,
  loadingText: string,
  size?: number,
  hideText?: boolean,
};

type LoadingState = {|
  currentText: ?Object,
|};

class Loading extends React.Component<LoadingProps, LoadingState> {
  timer: TimeoutID;

  longTimer: TimeoutID;

  noData: TimeoutID;

  state = {
    currentText: null,
  };

  componentDidMount() {
    const { loadingText } = this.props;

    // www.nngroup.com/articles/response-times-3-important-limits
    if (!loadingText) {
      this.timer = setTimeout(() => {
        this.setState({ currentText: messages.loadingText });
      }, 1000);
      this.longTimer = setTimeout(() => {
        this.setState({ currentText: messages.longLoadingText });
      }, 10000);
      this.noData = setTimeout(() => {
        this.setState({ currentText: messages.noDataText });
      }, 100000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    clearTimeout(this.longTimer);
    clearTimeout(this.noData);
  }

  render() {
    const { loadingText, intl, hideText = false, size = 80, ...restProps } = this.props;
    const { currentText } = this.state;
    if (!currentText && !loadingText) return null;

    if (loadingText) {
      clearTimeout(this.timer);
      clearTimeout(this.longTimer);
      clearTimeout(this.noData);
    }

    return (
      <Box style={styles.spinner}>
        <Image
          src={require('../app/dish_logo_beacon_animated_small.gif')}
          size={{ height: size, width: size, exact: true }}
        />
        {!hideText && (
          <Text {...restProps} style={() => styles.loadingTxt}>
            {loadingText || intl.formatMessage(currentText)}
          </Text>
        )}
      </Box>
    );
  }
}

export default injectIntl(Loading);
